import { useState, useMemo } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { brandingConstants } from "../PreviewStyles/constants";
import { appLogger } from "../../../../utils";

import "./styles.css";

import HeaderPreview from "../TVComponents/common/HeaderPreview";
import FirstPagePreview from "../TVComponents/common/FirstPagePreview";
import SecondPagePreview from "../TVComponents/common/SecondPagePreview";
import ThirdPagePreview from "../TVComponents/common/ThirdPagePreview";
import ThankYouPreview from "../TVComponents/common/ThankYouPreview";
import FooterPreview from "../TVComponents/common/FooterPreview";

const TVAgentpreview = (props: any) => {
  const {
    productParams,
    page,
    ClickedCat,
    technology,
    setClickedCatFbsCb,
    ClickedCatFbsVal,
    setClickedCat,
  } = props;

  appLogger.info({
    infoObj: {
      method: "TVAgentpreview",
      component: "add-product",
      fileName: "TVAgentpreview.tsx",
      props: props,
    },
  });

  const [previewAgent, setPreviewAgent] = useState<boolean>(false);
  // const [product, setProduct] = useState<any>(productInitialValues);
  const product =
    productParams?.productParams?.products?.[0]?.feedbackAgentSettings;
  const { branding = {} } = product;

  const handleTogglePreview = () => {
    setPreviewAgent((prevState) => !prevState);
  };

  const handleBtnPosition = (name: any) => {
    props.setClickedCat(name);
    const getStdFbs =
      productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.categories.filter(
        (e: any) => e.name === name
      );

    if (getStdFbs.length > 0 && Array.isArray(getStdFbs[0].feedbacks)) {
      props.setClickedCatFbsCb(getStdFbs[0].feedbacks);
    }
  };

  const handleConvertPxToPt = (value: string) => {
    const cleanValue = value.replace("px", "");
    const newValue = previewAgent
      ? `${cleanValue}pt`
      : parseInt(cleanValue) / 1.2 + "px";

    return newValue;
  };

  const handleFontPreview = (value: string) => {
    const cleanValue = value.replace("px", "");
    const newValue = previewAgent
      ? `${cleanValue}px`
      : parseInt(cleanValue) / 1.2 + "px";

    return newValue;
  };

  return (
    <>
      <Typography ref={props.generalPreviewRef}></Typography>
      <Typography className="prev-text-titile">
        Preview of page - {page} &nbsp;
      </Typography>
      {previewAgent && <Box className="general-settings-overlay" />}
      {!previewAgent && (
        <Grid container justifyContent="center" mt={1} mb={1}>
          <Typography
            className="tv-agent-preview-btn guideTourViewActualSize"
            onClick={handleTogglePreview}
            sx={{ color: "#0157FF", fontSize: 12 }}
          >
            Click to preview actual size
          </Typography>
        </Grid>
      )}
      <div style={{ height: "auto" }}>
        <div
          id={`tvpreviewIds${page}`}
          className={`${
            previewAgent ? "tv-preview-full" : "tv-preview-container"
          }`}
          style={{
            background: branding?.[brandingConstants.agentBackground],
            padding:
              previewAgent && page === 4
                ? "60px 60px 19px 60px!important"
                : previewAgent
                ? "120px 60px 19px 60px"
                : "20px",
          }}
        >
          <Grid
            container
            className={previewAgent ? "tv-responsive-overflow " : ""}
            flexDirection="column"
            flexWrap="nowrap"
          >
            <Typography className="tv-preview-close-icon">
              For Preview
              <span onClick={handleTogglePreview} className="prevclose">
                &nbsp; x &nbsp;Close&nbsp;
              </span>
            </Typography>

            {page !== 4 && (
              <Grid item xs={12}>
                <HeaderPreview
                  productParams={productParams}
                  branding={branding}
                  previewAgent={previewAgent}
                  product={product}
                />

                {page === 1 && (
                  <FirstPagePreview
                    product={product}
                    previewAgent={previewAgent}
                    branding={branding}
                    technology={technology}
                    handleBtnPosition={handleBtnPosition}
                    ClickedCat={props.ClickedCat}
                  />
                )}

                {page === 2 && (
                  <SecondPagePreview
                    product={product}
                    previewAgent={previewAgent}
                    branding={branding}
                  />
                )}

                {page === 3 && (
                  <ThirdPagePreview
                    product={product}
                    previewAgent={previewAgent}
                    branding={branding}
                    technology={technology}
                    handleBtnPosition={handleBtnPosition}
                    ClickedCat={props.ClickedCat}
                    ClickedCatFbsVal={props.ClickedCatFbsVal}
                  />
                )}
              </Grid>
            )}

            {page === 4 && (
              <ThankYouPreview product={product} previewAgent={previewAgent} />
            )}

            <FooterPreview
              previewAgent={previewAgent}
              branding={branding}
              technology={technology}
              page={page}
            />
          </Grid>
        </div>
      </div>
    </>
  );
};

export default TVAgentpreview;
